import React, { Component } from 'react';
import { connect } from 'react-redux';

import { userSetFieldFetch, userSetField } from './../../store/user/actions';
import PoliciesAndConditions from './PoliciesAndConditions';
import AgreementBox from './AgreementBox';

import moment from 'moment-timezone';

const bodyNoScrollClass = 'hide-scroll-agreement';

class AgreementInner extends Component {

    componentDidMount() {
        document.body.classList.add(bodyNoScrollClass);
    }

    componentWillUnmount() {
        document.body.classList.remove(bodyNoScrollClass);
    }

    constructor(props) {
        super(props);

        this.state = { isWelcomeComplete: false };
        this.onNextClick = this.onNextClick.bind(this);

    }

    onNextClick() {
        this.setState({ isWelcomeComplete: true });
    }

    renderViewWelcomeNewWriter() {
        return (
            <div>
                <h2>Welcome aboard!</h2>
                <p>
                    We are happy to see you at best-in-class freelance writing platform.
                    You are just several steps from starting on your first order!
                    Before we start, please read and accept Writer's Agreement.
                </p>
                <div className="ta-right mt20"><button onClick={this.onNextClick} className="btn btn-bright-success btn-md">Next</button></div>
            </div>
        );
    }

    renderViewWelldone() {
        const { saveCloseAgreementWizard } = this.props;
        return (
            <div>
                <h2>Welldone!</h2>
                <p>Please fill in required fields to start finding your first order.</p>
                <div className="ta-right mt20"><button onClick={saveCloseAgreementWizard} className="btn btn-bright-success btn-md">Next</button></div>
            </div>
        );
    }

    renderViewWelcomeBackWriter() {
        return (
            <div>
                <h2>Welcome Back!</h2>
                <p>We recently made some minor changes to our terms of use and need you to agree to them.</p>
                <p>Please read them carefully and accept. </p>
                <div className="ta-right mt20"><button onClick={this.onNextClick} className="btn btn-bright-success btn-md">Next</button></div>
            </div>
        );
    }

    renderViewAwesome() {
        const { saveCloseAgreementWizard } = this.props;
        return (
            <div>
                <h2>Awesome!</h2>
                <p>Now that we are through with formalities, we are happy to show your new writer cabinet. </p>
                <p>We'll guide you through the details of the new account.</p>
                <div className="ta-right mt20"><button onClick={saveCloseAgreementWizard} className="btn btn-bright-success btn-md">Next</button></div>
            </div>
        );
    }

    renderViewPolicies() {
        const { saveAgreement } = this.props;
        return (
            <div>
                <PoliciesAndConditions />
                <div className="ta-right mt20"><button onClick={saveAgreement} type="button" className="btn btn-bright-success">Agree and close</button></div>
            </div>
        );
    }

    renderContent() {
        const { isNewWriter, showAgreement } = this.props;
        const { isWelcomeComplete } = this.state;

        if (isNewWriter) {
            if (!isWelcomeComplete) {
                return this.renderViewWelcomeNewWriter();
            }
            else {
                if (showAgreement) {
                    return this.renderViewPolicies();
                }
                else {
                    return this.renderViewWelldone();
                }
            }
        } else {
            if (!isWelcomeComplete) {
                return this.renderViewWelcomeBackWriter();
            }
            else {
                if (showAgreement) {
                    return this.renderViewPolicies();
                }
                else {
                    return this.renderViewAwesome();
                }
            }
        }

    }

    render() {
        return (
            <AgreementBox containerRef={ref => this.containerRef = ref}>
                {this.renderContent()}
            </AgreementBox>
        );
    };
};

const mapStateToProps = state => ({
    profile: state.user,
    isNewWriter: moment(state.user.created_at).isAfter('2017-09-04'),
    showAgreement: !state.user.profile_tag_policies_agree || !state.user.profile_tag_terms_agree
});

const mapDispatchToProps = dispatch => ({
    saveAgreement: () => {
        dispatch(userSetFieldFetch('profile_tag_policies_agree', true));
        dispatch(userSetFieldFetch('profile_tag_terms_agree', true));
    },
    saveCloseAgreementWizard: () => dispatch(userSetField('showAgreementWizard', false))
});

const AgreementInnerConnected = connect(mapStateToProps, mapDispatchToProps)(AgreementInner);


const Agreement = props => {
    const { showAgreementWizard } = props;
    if (!showAgreementWizard) { return null; }

    return (
        <AgreementInnerConnected />
    );
};

export default connect(state => ({
    showAgreementWizard: state.user.showAgreementWizard
}))(Agreement);


// WEBPACK FOOTER //
// ./src/components/agreement/Agreement.js